__turbopack_context__.v({
  "input-preview__label": "tV6Weq_input-preview__label",
  "input-preview__value": "tV6Weq_input-preview__value",
});
